export default "__VITE_ASSET__189c95be__"